
export class TopUpCreditSucceededAction {
  static readonly type = '[Payment] Top up credit succeeded';

  constructor(public paymentIntent: any) {
  }
}
